<template>
	<div style="margin-top: 10px;">
		<Timeline :value="timeline" align="left">
            <template #marker="slotProps">
                <span v-if="slotProps.item.head===true" class="head-marker" :style="{backgroundColor: slotProps.item.color}" ><i class="pi pi-clock" style="font-size: 3em; color: limegreen;"></i></span>
                <span v-else-if="slotProps.item.current===true" class="current-marker" :style="{backgroundColor: slotProps.item.color}" ></span>
                <span v-else class="custom-marker" :style="{backgroundColor: slotProps.item.color}" ></span>
            </template>
            <template #opposite="slotProps">
                <!-- <span v-if="slotProps.item.current && slotProps.item.step !== 5" class="p-text-secondary" style="color: #007bff; border: 1px solid #007bff; padding: 5px; border-radius: 10px;">待处理</span> -->
                <div v-if="slotProps.item.date">
                    <div style="font-size: large">{{showDay(slotProps.item.date)}}</div>
                    <div style="font-size: medium">{{showYear(slotProps.item.date)}}</div>
                </div>
            </template>
            <template #content="slotProps">
                <div :style="{'border': slotProps.item.current?'2px solid limegreen':null, 'border-radius': '10px', 'padding': '5px'}">
                    <div style="font-size: large; color: #007bff">
                        {{slotProps.item.stepName}}
                    </div>
                    <div v-if="slotProps.item.person">处理人：{{slotProps.item.person}}</div>
                    <div v-if="slotProps.item.result===true || slotProps.item.result===false">
                        <span v-if="slotProps.item.result===true">处理结果：通过</span>
                        <span v-else>
                            <span style="color: red">处理结果：不通过</span>
                            <i class="fa fa-info-circle" v-tooltip.top="'审核意见：\n'+(slotProps.item.comment?slotProps.item.comment:'无')" style="color: orange; margin-left: .5em; font-size: medium; cursor: pointer" ></i>
                        </span>
                    </div>
                    <div v-if="slotProps.item.date">处理时间：{{showTime(slotProps.item.date)}}</div>
                </div>
                <br>
            </template>
        </Timeline>
	</div>
</template>

<script>
// import QuantizationService from '../service/QuantizationService';
const moment = require('moment');

export default {
	data() {
        return {
			
		}
	},
	props: {
		timeline: Array
	},
	created() {
		// this.quantizationService = new QuantizationService();
	},
    methods: {
        showYear(value) {
			return moment(value).format("YYYY");
        },
        showDay(value) {
			return moment(value).format("MM-DD");
		},
        showDate(value) {
			return moment(value).format("YYYY-MM-DD");
		},
		showTime(value) {
			return moment(value).format("HH:mm:ss");
		},
		showDateTime(value) {
			return moment(value).format("YYYY-MM-DD HH:mm");
		},
    },
	components: {

	},
	computed: {
		
	}
}
</script>

<style scoped>
.head-marker {
    width: 3em;
    height: 3em;
    text-align: center;
}

.current-marker {
    width: 30px;
    height: 30px;
    border: 6px solid limegreen;
    border-radius:15px;
}

.custom-marker {
    width: 20px;
    height: 20px;
    border-radius:20px;
    border: 2px solid limegreen;
}

</style>